import * as ReactDOM from 'react-dom/client';
import App from './main';
import { ModalProvider } from '@lasbe/react-modal';
import { CookiesProvider } from 'react-cookie';
const style = {
  background: 'white',
  boxShadow:
    '0px 8px 18px 0px rgba(0, 0, 0, 0.12), 0px 12px 42px 0px rgba(0, 0, 0, 0.12)',
  borderRadius: '1rem',
  padding: 0,
  border: 'none',
  paddingTop: '2.5rem',
  Position: 'relative',
  width: '348px',
};

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <CookiesProvider>
    <ModalProvider
      options={{
        body: style,
      }}
    >
      <App />
    </ModalProvider>
  </CookiesProvider>
);
